import React from "react";
import ButtonLink from '../ButtonLink';
import style from '../../../scss/components/Contact/ThankYou.scss';

export default class ThankYou extends React.Component {
    render() {
        return <>
            <div className="form-msg">
                <h2>Thank You!</h2>
                <p>Thank you for contacting HunterLab. We have received your inquiry and will respond to your request as soon as possible.</p>
                <ButtonLink text="Return Home" className="btn btn-default" url="/" ></ButtonLink>
            </div>
        </>
    }
}